import "./scss/index.scss";
import React from "react";
import InstagramEmbed from "react-instagram-embed";
var appId = process.env.FACEBOOK_APP_ID;
var clientToken = process.env.FACEBOOK_CLIENT_TOKEN;
var clientAccessToken = "".concat(appId, "|").concat(clientToken);
export function InstagramItems(_ref) {
  var postUrls = _ref.postUrls;
  return React.createElement("ul", {
    className: "instagram-items"
  }, postUrls === null || postUrls === void 0 ? void 0 : postUrls.map(function (url) {
    return url ? React.createElement("li", {
      key: url
    }, React.createElement(InstagramEmbed, {
      url: url,
      clientAccessToken: clientAccessToken,
      hideCaption: true
    })) : null;
  }));
}